import { Redirect, Route, Switch } from 'wouter';
import useDomain from './hooks/useDomain';
import { DOMAINS, NECTAR_URL } from './lib/constants';
import { getUrl } from './lib/utils';

import {
  MockPage,
  NcJennyPage,
  NcLPPage,
  BasicLandingPage,
  NcElizaPage,
  NectarRoleplayPage,
} from './pages';
import DynamicWrapper from './components/DynamicWrapper';
import { AuthProvider } from './components/auth/AuthProvider';
import { getNectarAuthUrl } from './lib/utils';
import { MetaPixel, trackEvent } from './lib/analytics';

const App = () => {
  const domain = useDomain();

  console.log('domain', domain);

  if (domain === DOMAINS.NECTAR_DESIRE) {
    window.location.href = getUrl(NECTAR_URL);
    return;
  }

  if (domain === DOMAINS.NECTAR_ROLEPLAY) {
    return <NectarRoleplayPage />;
  }

  if (domain === DOMAINS.NECTAR_LOVE) {
    return <MockPage name='nectar roleplay' />;
  }

  // DOMAINS.NECTAR_COMPANIONS
  return (
    <DynamicWrapper
      onAuthSuccess={(args) => {
        // Track signup with Meta Pixel only for NEW users (not returning logins)
        if (args?.user?.newUser) {
          trackEvent('CompleteRegistration', {
            content_name: 'Landing Page Signup',
            status: 'complete',
          });
        }
        const authURL = getNectarAuthUrl('/pricing');
        window.location.href = authURL;
      }}
    >
      <AuthProvider>
        <Switch>
          {/* Basic form*/}
          <Route path='/' component={BasicLandingPage} />
          <Route path='/eliza' component={BasicLandingPage} />
          <Route path='/dani' component={BasicLandingPage} />

          {/* Eliza v2 form */}
          <Route path='/eliza_v2' component={NcElizaPage} />

          {/* Redirect */}
          <Route path='/lp' component={NcLPPage} />

          {/* Marketing landing page */}
          <Route path='/jenny' component={NcJennyPage} />
        </Switch>
        <MetaPixel />
      </AuthProvider>
    </DynamicWrapper>
  );
};

export default App;
